import React from "react";
import { SearchSortBy, SortFilterProps } from "~/search-sort-by";
import { ProjectSortBy, ProjectSortByLabels } from "~/gql/types";
import { ProjectChargesFilter } from "./types";

export const SortCharges: React.FC<
  Omit<SortFilterProps<ProjectChargesFilter, ProjectSortBy>, "options">
> = (props) => <SearchSortBy {...props} options={ProjectSortByLabels} />;
